export default __webpack_public_path__ + "static/media/suspend-2.45723ea8.png";